export const SET_REPORT_LOCK_ACQUIRED: string = "set_report_lock_acquired";
export const SET_REPORT_LOCK_RELEASED: string = "set_report_lock_released";
export const SET_REPORT_DRAFT_UPDATED: string = "set_report_draft_updated";
export const SET_CASE_ASSIGNMENT_CHANGED: string = "set_case_assignment_changed";
export const CLEAR_CASE_ASSIGNMENT_CHANGED: string = "clear_case_assignment_changed";
